package com.xtream.ui.tv.presentation.navbar
 
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.FastOutSlowInEasing
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInHorizontally
import androidx.compose.animation.slideOutHorizontally
import androidx.compose.foundation.focusGroup
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsFocusedAsState
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredSize
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.PlaylistPlay
import androidx.compose.material.icons.rounded.Search
import androidx.compose.material3.BadgedBox
import androidx.compose.material3.DrawerValue
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.NavigationDrawerItemDefaults
import androidx.compose.material3.Text
import androidx.compose.material3.rememberDrawerState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.runtime.withFrameNanos
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.focusRestorer
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.geometry.CornerRadius
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.onKeyEvent
import androidx.compose.ui.input.key.type
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.platform.LocalWindowInfo
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.LayoutDirection
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.lifecycle.compose.LifecycleResumeEffect
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.lifecycle.viewmodel.navigation3.rememberViewModelStoreNavEntryDecorator
import androidx.navigation3.runtime.entryProvider
import androidx.navigation3.runtime.rememberDecoratedNavEntries
import androidx.navigation3.runtime.rememberSaveableStateHolderNavEntryDecorator
import androidx.navigation3.ui.NavDisplay
import com.xtream.composeapp.SharedBuildKonfig
import com.xtream.composeapp.data.Screen
import com.xtream.composeapp.platform.PlatformType
import com.xtream.composeapp.platform.currentPlatform
import com.xtream.composeapp.presentation.ui.navigation.RootNavViewModel
import com.xtream.composeapp.presentation.ui.navigation.data.NavIcon
import com.xtream.composeapp.presentation.ui.navigation.data.NavigationItem
import com.xtream.composeapp.presentation.widget.BackHandler
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.account_text
import com.xtream.sharedResources.resources.clapper_open
import com.xtream.sharedResources.resources.gear_filled
import com.xtream.sharedResources.resources.home
import com.xtream.sharedResources.resources.home_2
import com.xtream.sharedResources.resources.live
import com.xtream.sharedResources.resources.movies
import com.xtream.sharedResources.resources.playlists
import com.xtream.sharedResources.resources.screen_ic
import com.xtream.sharedResources.resources.search
import com.xtream.sharedResources.resources.series
import com.xtream.sharedResources.resources.settings
import com.xtream.sharedResources.resources.tv_ic1
import com.xtream.sharedResources.resources.user_filled
import com.xtream.composeapp.viewmodel.UserViewModel
import com.xtream.ui.tv.presentation.account.ComposeAccountTvScreen
import com.xtream.ui.tv.presentation.discover.TvDiscoverScreen
import com.xtream.ui.tv.presentation.home.TvHomeScreen
import com.xtream.ui.tv.presentation.movies.MoviesTvScreen
import com.xtream.ui.tv.presentation.playlist.PlaylistScreen
import com.xtream.ui.tv.presentation.prefs.ComposeSettingsTvScreen
import com.xtream.ui.tv.presentation.search.TvSearchScreen
import com.xtream.ui.tv.presentation.series.TvShowsTvScreen
import com.xtream.ui.tv.presentation.tvchannels.NewTvChannelsPlayerScreen
import com.xtream.ui.tv.presentation.tvchannels.TvChannelsBrowseTvScreen
import com.xtream.ui.tv.presentation.widget.ModalNavigationDrawer
import com.xtream.ui.ui.util.extensions.throttleAllKeys
import com.xtream.ui.ui.widget.CustomNavigationDrawerItem
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf


@Composable
fun SideNavBarScreen(

){




     val closedDrawerWidth:Dp = 100.dp





        TvSideNavigationBar(
              closedDrawerWidth= closedDrawerWidth,

       )




}



@Composable
private fun TvSideNavigationBar(modifier: Modifier=Modifier
                                ,

                                userViewModel: UserViewModel = koinViewModel(),
                                closedDrawerWidth:Dp= 135.dp,
                                openedDrawerWidth:Dp = 190.dp,
) {


    val defaultRoute = remember { Screen.Home }
    val rootNavViewModel: RootNavViewModel = koinViewModel(
        key = "TvSideNavigationBar",
        parameters = { parametersOf(defaultRoute) })
    val navController = remember { rootNavViewModel.backStack }

    val columnsContentPadding = PaddingValues(vertical = 48.dp)
    val rowsContentPadding = PaddingValues(start = closedDrawerWidth , end = 48.dp)
    var isFullscreen by remember { mutableStateOf(false) }


    val entryProvider = rememberDecoratedNavEntries(
        backStack = navController,
        entryDecorators = listOf(
            // Add the default decorators for managing scenes and saving state
            // Add the default decorators for managing scenes and saving state
            rememberSaveableStateHolderNavEntryDecorator(),
            // Then add the view model store decorator
            rememberViewModelStoreNavEntryDecorator()
        ),
        entryProvider = entryProvider {


            entry<Screen.Search> {

                TvSearchScreen(
                    it,
                    rowsContentPadding = rowsContentPadding,
                    contentPadding = columnsContentPadding
                )
            }
            entry<Screen.Discover> {
                TvDiscoverScreen(
                    it,
                    rowsContentPadding = rowsContentPadding,
                    contentPadding = columnsContentPadding
                )
            }

            entry<Screen.Playlists> {
                PlaylistScreen(
                     contentPadding = rowsContentPadding
                )

            }


            entry<Screen.MenuLiveStreamPlayer> { arg ->
                val density = LocalDensity.current
                val layoutWidth = with(density) {
                    LocalWindowInfo.current.containerSize.width.toDp()
                }
                var requestFocusOnStart by rememberSaveable { mutableStateOf(false) }


                NewTvChannelsPlayerScreen(
                    layoutWidth = if (isFullscreen) layoutWidth else layoutWidth - closedDrawerWidth,
                    requestFocusOnStart = requestFocusOnStart,

                    modifier = Modifier
                        .onFocusChanged {
                            if (it.hasFocus) {
                                requestFocusOnStart = false
                            }

                        }
                        .padding(start = if (isFullscreen) 0.dp else closedDrawerWidth),
                    streamId = arg.id, categoryId = arg.categoryId, title = arg.title,
                    navKey = arg,
                    onEnterFullScreen = {
                        isFullscreen = true

                    },
                    onExitFullScreen = {
                        isFullscreen = false

                    },
                    //mainLayoutStartPadding = closedDrawerWidth
                )


            }
            entry<Screen.Browse> {
              /*  TvTabSupportBrowse(
                    modifier = Modifier,
                    rowsContentPadding = rowsContentPadding,
                )*/
            }
            entry<Screen.Home> {
                TvHomeScreen(
                    navKey = it,
                    //requestFocusOnStart = true,
                    rowsContentPadding = rowsContentPadding
                )
            }
            entry<Screen.LiveTv> {
                TvChannelsBrowseTvScreen(
                    rowsContentPadding = rowsContentPadding, contentPadding = columnsContentPadding
                )
            }

            entry<Screen.Movies> {
                MoviesTvScreen(
                    navKey = it,
                    rowsContentPadding = rowsContentPadding,
                    contentPadding = columnsContentPadding
                )
            }
            entry<Screen.TvShows> {
                TvShowsTvScreen(
                    it,
                    rowsContentPadding = rowsContentPadding,
                    contentPadding = columnsContentPadding
                )
            }
            entry<Screen.AccountInfo> {
                ComposeAccountTvScreen(
                    rowsContentPadding = rowsContentPadding,
                    contentPadding = columnsContentPadding
                )
            }
            entry<Screen.Settings> {
                //val focusManager=LocalFocusManager.current
                ComposeSettingsTvScreen(
                    navKey = it,
                    contentPadding = rowsContentPadding
                )
            }
        })


    val userState by userViewModel.loggedInUserFlow.collectAsStateWithLifecycle(null)//?.?.userInfo?.isTrial == "1"
    val isTrial = userState?.userInfo?.isTrial == "1"
    // 1. Resolve ALL composables first
    val navigationItems = remember {
        listOf(
            NavigationItem(
                title = Res.string.search,
                icon = NavIcon.Vector(Icons.Rounded.Search),
                route = Screen.Search()
            ),
           /* NavigationItem(
                title = Res.string.discover,
                icon = NavIcon.Resource( Res.drawable.sparkle) , // or NavIcon.Resource if it's an XML drawable
                route = Screen.Discover
            ),*/
            NavigationItem(
                title = Res.string.home,
                icon = NavIcon.Resource(Res.drawable.home_2),
                route = Screen.Home
            ),
            NavigationItem(
                title = Res.string.live,
                icon = NavIcon.Resource(Res.drawable.tv_ic1),
                route = Screen.MenuLiveStreamPlayer(null, null, null)
            ),
            NavigationItem(
                title = Res.string.movies,
                icon = NavIcon.Resource(Res.drawable.clapper_open),
                route = Screen.Movies
            ),
            NavigationItem(
                title = Res.string.series,
                icon = NavIcon.Resource(Res.drawable.screen_ic),
                route = Screen.TvShows
            ),
            NavigationItem(
                title = Res.string.playlists,
                icon = NavIcon.Vector(Icons.AutoMirrored.Default.PlaylistPlay),
                route = Screen.Playlists
            ),

        )
    }

    val accountItem = remember {
        NavigationItem(
            title = Res.string.account_text,
            icon = NavIcon.Resource(Res.drawable.user_filled),
            route = Screen.AccountInfo
        )
    }

    val settingItem = remember {
        NavigationItem(
            title = Res.string.settings,
            icon = NavIcon.Resource(Res.drawable.gear_filled),
            route = Screen.Settings
        )
    }
    val defaultItemFocusRequester = remember { FocusRequester() }
    val drawerState = rememberDrawerState(DrawerValue.Closed)
    val isRtl = LocalLayoutDirection.current == LayoutDirection.Rtl


    //by  remember(drawerState.currentValue) { mutableStateOf(if(drawerState.currentValue==DrawerValue.Open) 200.dp else 100.dp) }
    val density = LocalDensity.current


    val drawerWidth by remember(drawerState) {
        derivedStateOf {
            if (drawerState.currentValue == DrawerValue.Open) openedDrawerWidth else closedDrawerWidth
        }
    }


    /*val contentWidthDp = with(density) {
        LocalConfiguration.current.screenWidthDp.dp - closedDrawerWidth
    }

    val drawerRequiredWidthDp = with(density) {
        LocalConfiguration.current.screenWidthDp.dp + openedDrawerWidth
    }
    val translationXShift = with(density) {

        closedDrawerWidth.toPx().let {
            if (isRtl) -it else it
        }
    }*/


    val drawerFocusRequester = remember { FocusRequester() }
    val contentFocusRequester = remember { FocusRequester() }

    val localFocusManager = LocalFocusManager.current
    val isDrawerOpen = drawerState.currentValue == DrawerValue.Open
    var drawerFocusEnabled by rememberSaveable { mutableStateOf(false) }
    val scope = rememberCoroutineScope()

    fun onNavItemFocused(route: Screen) {

        if (navController.size > 1)
            rootNavViewModel.pop()
        rootNavViewModel.navigate(route)

        /*Log.d("entry", "_____________________")
        navController.forEachIndexed { index, entry ->
            Log.d("entry", "$index - $entry ")
        }*/
    }

    fun onNavItemClick(route: Screen) {
         //val sameItem = navController.lastOrNull() == route
        scope.launch{
            drawerState.close()
        }
        contentFocusRequester.requestFocus()
    }

    fun isSelectedRoute(route: Screen) = navController.lastOrNull() == route


    val direction = if (isRtl) 1 else -1

    val animatedTranslationX by animateFloatAsState(
        targetValue = when {
            isFullscreen -> closedDrawerWidth.value * direction // slide fully off screen
            drawerState.currentValue == DrawerValue.Open -> 0f
            else -> 12f * direction
        },
        animationSpec = tween(durationMillis = 200, easing = FastOutSlowInEasing),
        label = "drawerTranslationX"
    )
    // Inside TvSideNavigationBar
    val navItemRequesters = remember {
        navigationItems.plus(accountItem).plus(settingItem)
            .associate { it.route to FocusRequester() }
    }
    // Place this after navItemRequesters is defined
    val currentRoute = navController.lastOrNull()
    val activeNavItemRequester = remember(currentRoute) {
        navItemRequesters[currentRoute]
    }

     ModalNavigationDrawer(

        drawerState = drawerState,
        modifier = modifier
            .fillMaxHeight()

            .focusRestorer(contentFocusRequester)
            .throttleAllKeys(70)
        ,
         scrimBrush =scrimBrush(),
        content = {


           Box(
                modifier = Modifier
                    .fillMaxSize()

               /* .graphicsLayer {
                    compositingStrategy = CompositingStrategy.Offscreen
                }
                .drawWithContent {
                    drawContent()

                    drawRect(
                        brush = Brush.horizontalGradient(
                            colors = listOf(
                                Color.Black.copy(alpha = 0f),   // transparent — always the "start" stop
                                Color.Black.copy(alpha = .1f),
                                Color.Black.copy(alpha = 1f)    // opaque — always the "end" stop
                            ),
                            startX = if (isRtl) size.width else 0f,
                            endX = if (isRtl) size.width - closedDrawerWidth.toPx()
                            else closedDrawerWidth.toPx()
                        ),
                        blendMode = BlendMode.DstIn
                    )
                }*/

               ,

                content = {

                    NavDisplay(
                        modifier = Modifier
                            .focusRequester(contentFocusRequester),
                        entries = entryProvider,

                        onBack = {
                            if (navController.size > 1) {
                                rootNavViewModel.pop()
                                if(isDrawerOpen) {
                                    navItemRequesters[ navigationItems[1].route]?.requestFocus()
                                }
                            }
                        },


                    )

                })

        },
        drawerContent = {

            Column(
                modifier = Modifier
                    .fillMaxHeight()
                    .width(drawerWidth)
                    .padding(start = 48.dp)
                    .graphicsLayer {
                        translationX = animatedTranslationX.dp.toPx()

                    }
                    .verticalScroll(rememberScrollState())

                    .onKeyEvent { keyEvent ->
                        val enable =
                            keyEvent.type == KeyEventType.KeyDown || (currentPlatform == PlatformType.WEB && keyEvent.type == KeyEventType.KeyUp)

                        if (enable) {
                            // 🚀 Use the platform-agnostic key property
                            when (keyEvent.key) {
                                Key.DirectionRight -> {
                                    if (!isRtl) {
                                        contentFocusRequester.requestFocus()
                                    }
                                    !isRtl // Returns true if consumed, false otherwise
                                }

                                Key.DirectionLeft -> {
                                    if (isRtl) {
                                        contentFocusRequester.requestFocus()
                                    }
                                    isRtl // Returns true if consumed, false otherwise
                                }

                                else -> false
                            }
                        } else {
                            false
                        }
                    }/*.onKeyEvent { keyEvent ->
                        if (keyEvent.type == KeyEventType.KeyDown) {
                            // 🚀 Use the platform-agnostic key property
                            when (keyEvent.key) {
                                Key.DirectionRight -> {
                                    if (!isRtl) {
                                        contentFocusRequester.requestFocus()
                                    }
                                    !isRtl // Returns true if consumed, false otherwise
                                }

                                Key.DirectionLeft -> {
                                    if (isRtl) {
                                        contentFocusRequester.requestFocus()
                                    }
                                    isRtl // Returns true if consumed, false otherwise
                                }

                                else -> false
                            }
                        } else {
                            false
                        }
                    }
*/
                    .focusRequester(drawerFocusRequester)
                    //.focusRestorer( navItemRequesters[ navigationItems.getOrNull(1)?.route]?: remember { FocusRequester() })

                    //
                    .focusProperties {
                        onEnter = {
                            // if (!drawerFocusEnabled || isFullscreen )
                            //   cancelFocusChange()
                            activeNavItemRequester?.requestFocus()
                        }
                        /*  onExit = {
                            drawerFocusRequester.saveFocusedChild()
                        }*/
                        //  left = contentFocusRequester

                        /*canFocus =   isDrawerOpen &&drawerFocusEnabled*/
                    }
                    .focusGroup(),


                horizontalAlignment = Alignment.Start
            ) {
                Spacer(modifier = Modifier.padding(top = 24.dp))


// ── TOP: Account ──────────────────────────────
                NavDrawerItem(
                    item = accountItem,
                    modifier = Modifier.focusRequester(
                        navItemRequesters[accountItem.route] ?: remember { FocusRequester() }),
                    index = 0,
                    selected = isSelectedRoute(accountItem.route),
                    isDrawerOpen = isDrawerOpen,
                    onClick = { onNavItemClick(accountItem.route) },
                    onFocusChange = { focused ->
                        if (focused) onNavItemFocused(accountItem.route)
                    },
                    badge = {
//TODO TrialBadge (isTrial)
                    }
                )

// pushes nav items to center
                Spacer(modifier = Modifier.weight(1f))

// ── MIDDLE: Nav items ─────────────────────────
                navigationItems.forEachIndexed { index, item ->
                    NavDrawerItem(
                        item = item,
                        index = index.plus(1),
                        modifier = Modifier
                            .focusRequester(
                                navItemRequesters[item.route] ?: remember { FocusRequester() }),


                        selected = isSelectedRoute(item.route),
                        isDrawerOpen = isDrawerOpen,
                        onClick = { onNavItemClick(item.route) },
                        onFocusChange = { focused ->
                            if (focused) onNavItemFocused(item.route)
                        }
                    )
                    Spacer(modifier = Modifier.height(16.dp))
                }

// pushes settings to bottom
                Spacer(modifier = Modifier.weight(1f))

// ── BOTTOM: Settings ──────────────────────────
                NavDrawerItem(
                    item = settingItem,
                    modifier = Modifier.focusRequester(
                        navItemRequesters[settingItem.route] ?: remember { FocusRequester() }),
                    index = navigationItems.size.plus(1),
                    selected = isSelectedRoute(settingItem.route),
                    isDrawerOpen = isDrawerOpen,
                    onClick = { onNavItemClick(settingItem.route) },
                    onFocusChange = { focused ->
                        if (focused) onNavItemFocused(settingItem.route)
                    }
                )

                Text(
                    text = "V${SharedBuildKonfig.VERSION_NAME}",
                    style = MaterialTheme.typography.labelSmall,
                    color = MaterialTheme.colorScheme.onBackground.copy(alpha = .5f),
                )

                Spacer(modifier = Modifier.height(16.dp))
            }


        }
)







LifecycleResumeEffect(Unit) {
scope.launch(Dispatchers.Main) {
// Wait exactly 1 rendering frame loop to let layout measurements complete
withFrameNanos { /* No-op: just yields until the next frame tick */ }

// Now safely enable your focus hooks
drawerFocusEnabled = true
// contentFocusRequester.requestFocus()
}

onPauseOrDispose {
drawerFocusEnabled = false
}
}


/*LifecycleEventEffect(Lifecycle.Event.ON_RESUME) {

}
LifecycleEventEffect(Lifecycle.Event.ON_PAUSE) {

}*/

BackHandler(enabled = drawerFocusEnabled && drawerState.currentValue == DrawerValue.Closed) {
println("BackHandler")
scope.launch {
drawerState.open()
}
//if (!drawerFocusRequester.restoreFocusedChild())
drawerFocusRequester.requestFocus()
}

//LaunchedEffect(drawerState.currentValue) {
// if (drawerState.currentValue == DrawerValue.Closed)
//   contentFocusRequester.requestFocus()
//}

}



@Composable
fun NavDrawerItem(
modifier: Modifier=Modifier,
unselectedContainerColor: Color = Color.Transparent,
badge:  @Composable (BoxScope.() -> Unit)? = null,
item: NavigationItem,
selected: Boolean=false,
index:Int=-1,
selectedBorderColor: Color = MaterialTheme.colorScheme.primary.copy(alpha = .8f),
onFocusChange: (Boolean) -> Unit = {},
isDrawerOpen: Boolean=true,
onClick: () -> Unit,) {
val titleText = stringResource(item.title)

val interactionSource = remember { MutableInteractionSource() }
val focusState by interactionSource.collectIsFocusedAsState()
val shape = RoundedCornerShape(
topStart = 0.dp,
bottomStart = 0.dp,
topEnd = 4.dp,
bottomEnd = 4.dp
)
LaunchedEffect(focusState) {
onFocusChange(focusState)
}
CustomNavigationDrawerItem(
interactionSource = interactionSource,
modifier = modifier
//.height(26.dp)
,

shape = shape, // Rounded corners

selected = selected,
onClick = onClick,
icon = {
if (item.icon != null)
BadgedBox(
badge = { badge?.invoke(this) },

) {

// 2. Resolve the painter dynamically based on the NavIcon sealed class subtype
val iconPainter = when (val iconType = item.icon) {
is NavIcon.Resource -> painterResource(iconType.res)
is NavIcon.Vector -> rememberVectorPainter(iconType.imageVector)
}
/*   if (selected)
HorizontalDivider(modifier= Modifier.align(Alignment.BottomCenter).clip(shape = shape), color = MaterialTheme.colorScheme.primary, thickness = 3.dp)
*/  Icon(
modifier = Modifier
/*  .padding(vertical = 4.dp)
.padding(start = 16.dp, end = 4.dp)*/
.requiredSize(20.dp)
.drawBehind {
 val strokeWidth = 3.dp.toPx()
 // Draw line across the bottom
 val cornerRadius = 4.dp.toPx()
 val topPadding = 3.dp.toPx() // push the line down a bit


 drawRoundRect(
     color = if (!selected) Color.Transparent else selectedBorderColor,
     topLeft = Offset(0f, size.height + topPadding),
     size = Size(size.width, strokeWidth),
     cornerRadius = CornerRadius(cornerRadius, cornerRadius)
 )
},
painter = iconPainter,
contentDescription = titleText
)

}

},
//alwaysShowLabel = navController.lastOrNull() ==item.route,

label = {

DrawerLabel(
title = titleText,
index = index,
isDrawerOpen = isDrawerOpen,
selected = selected,
focusState = focusState
)

},
colors = NavigationDrawerItemDefaults.colors(
selectedIconColor = if (focusState) selectedBorderColor /* MaterialTheme.colorScheme.primary*/ else MaterialTheme.colorScheme.onSurface,

/*if (focused) MaterialTheme.colorScheme.onPrimary else*/
selectedTextColor = /* if (focusState) selectedBorderColor MaterialTheme.colorScheme.primary else*/ MaterialTheme.colorScheme.onSurface,
selectedContainerColor = /*if (focused) MaterialTheme.colorScheme.onSurface else*/ Color.Transparent,
unselectedContainerColor = unselectedContainerColor,

)
)

}
@Composable
private fun DrawerLabel(
title: String,
index: Int,
isDrawerOpen: Boolean,
selected: Boolean,
focusState: Boolean
) {
val isRtl = LocalLayoutDirection.current == LayoutDirection.Rtl
val direction = if (isRtl) 1 else -1
val offsetPx = with(LocalDensity.current) { (12 * direction).dp.roundToPx() }

AnimatedVisibility(
visible = isDrawerOpen,
enter = fadeIn(
animationSpec = tween(durationMillis = 180, delayMillis = index * 55)
) + slideInHorizontally(
animationSpec = tween(
durationMillis = 220,
delayMillis = index * 55,
easing = FastOutSlowInEasing
),
initialOffsetX = { offsetPx }
),
exit = fadeOut(
animationSpec = tween(durationMillis = 80)
// ✅ no delay — all items collapse together instantly
) + slideOutHorizontally(
animationSpec = tween(durationMillis = 80),
targetOffsetX = { offsetPx }
)
) {
Text(
title,
maxLines = 1,
fontWeight = if (selected || focusState) FontWeight.ExtraBold else FontWeight.SemiBold,
style = MaterialTheme.typography.titleMedium,
fontSize = 14.sp,
)
}
}

/*

@Composable
fun CustomNavigationDrawerItem(
label: @Composable () -> Unit,
selected: Boolean,
onClick: () -> Unit,
modifier: Modifier = Modifier,
icon: (@Composable () -> Unit)? = null,
badge: (@Composable () -> Unit)? = null,
shape: Shape =  MaterialTheme.shapes.extraSmall,
colors: NavigationDrawerItemColors = NavigationDrawerItemDefaults.colors(),
interactionSource: MutableInteractionSource? = null
) {
*/
/*Button(onClick,
colors = ButtonDefaults.buttonColors(
containerColor = colors.containerColor(selected).value,
)
) {
if (icon != null) {
val iconColor = colors.iconColor(selected).value
CompositionLocalProvider(LocalContentColor provides iconColor, content = icon)
Spacer(Modifier.width(12.dp))
}
Box(Modifier.weight(1f)) {
val labelColor = colors.textColor(selected).value
CompositionLocalProvider(LocalContentColor provides labelColor, content = label)
}
if (badge != null) {
Spacer(Modifier.width(12.dp))
val badgeColor = colors.badgeColor(selected).value
CompositionLocalProvider(LocalContentColor provides badgeColor, content = badge)
}    }*//*

Surface(
selected = selected,
onClick = onClick,
shape =  SelectableSurfaceDefaults.shape(
shape = MaterialTheme.shapes.extraSmall
),
modifier =
modifier
.semantics { role = Role.Tab }
.heightIn(min = 30.dp, max = 30.dp)
.fillMaxWidth()
.clickable(
interactionSource = interactionSource,
onClick = onClick,
indication = null // Disables the ripple effect

)
.indication(
interactionSource = remember { MutableInteractionSource() },
indication = null
), // <- Disable default indication


//shape = shape,
//color = colors.containerColor(selected).value,
colors = SelectableSurfaceDefaults.colors(
focusedContainerColor = Color.Transparent,
selectedContainerColor = Color.Transparent,
containerColor = Color.Transparent,
pressedContainerColor = Color.Transparent,
pressedSelectedContainerColor = Color.Transparent,
disabledContainerColor = Color.Transparent,

),
//interactionSource = interactionSource,
) {
Row(
// Modifier.padding(end = 24.dp),
verticalAlignment = Alignment.CenterVertically
) {
if (icon != null) {
val iconColor = colors.iconColor(selected).value
CompositionLocalProvider(LocalContentColor provides iconColor, content = icon)
Spacer(Modifier.width(32.dp))
}
Box(Modifier.weight(1f)) {
val labelColor = colors.textColor(selected).value
CompositionLocalProvider(LocalContentColor provides labelColor, content = label)
}
if (badge != null) {
Spacer(Modifier.width(12.dp))
val badgeColor = colors.badgeColor(selected).value
CompositionLocalProvider(LocalContentColor provides badgeColor, content = badge)
}
}


}
}
*/



@Composable
fun scrimBrush(): Brush {
val backgroundColor =     MaterialTheme.colorScheme.background

val layoutDirection = LocalLayoutDirection.current

val colors = remember {
listOf(
backgroundColor,
backgroundColor.copy(alpha = 0.9f),
backgroundColor.copy(alpha = 0.15f),
backgroundColor.copy(alpha = 0.1f),
backgroundColor.copy(alpha = 0.05f)
)
}

return if (layoutDirection == LayoutDirection.Ltr) {
Brush.horizontalGradient(colors = colors)
} else {
// reverse colors for RTL
Brush.horizontalGradient(colors = colors.reversed())
}
}